
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Users, CheckCircle, Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

interface InviteGroupViewProps {
  groupName: string;
  memberCount: number;
  isJoining: boolean;
  onJoinGroup: () => void;
  onCancel: () => void;
}

export const InviteGroupView = ({
  groupName,
  memberCount,
  isJoining,
  onJoinGroup,
  onCancel
}: InviteGroupViewProps) => {
  const { t } = useTranslation();
  
  return (
    <div className="flex flex-1 items-center justify-center p-4">
      <Card className="w-full max-w-md border-2 border-primary/20 shadow-xl dark:border-primary/30 overflow-hidden">
        <div className="absolute h-1 w-full top-0 left-0 bg-gradient-to-r from-primary to-green"></div>
        <CardHeader className="text-center pt-8">
          <CardTitle className="text-xl sm:text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-primary to-green">
            {groupName}
          </CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-6">
          <p className="text-muted-foreground">
            {t('groups.groupInvite.invited')}
          </p>
          <div className="rounded-lg bg-primary/5 dark:bg-primary/10 p-4 flex items-center justify-center gap-3">
            <Users className="h-5 w-5 text-primary" />
            <p className="text-sm font-medium">
              {t('groups.membersCount', { count: memberCount })}
            </p>
          </div>
        </CardContent>
        <CardFooter className="flex flex-col gap-3 pb-6">
          <Button
            onClick={onJoinGroup}
            size="mobile" 
            rounded="lg"
            variant="gradient"
            className="w-full shadow-md transition-all"
            disabled={isJoining}
          >
            {isJoining ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                {t('groupInvite.joining')}
              </>
            ) : (
              <>
                <CheckCircle className="mr-2 h-4 w-4" />
                {t('groups.groupInvite.joinGroup')}
              </>
            )}
          </Button>
          <Button
            variant="outline"
            onClick={onCancel}
            size="mobile"
            rounded="lg"
            className="w-full"
          >
            {t('groups.cancel')}
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};
